<template lang="pug">

    div
      div( v-if="$apollo.loading" ) Loading, please wait...
      div( v-else-if="userMany" )
        MInput(
          type="select"
          v-bind:name="inputName"
          filterable
          v-bind:label="label"
          v-bind:options="getUserOptions()"
          v-on:change="onUserChange"
          v-bind:value="userId"
        )

</template>

<style lang="scss" scoped>
</style>

<script>
import Vue from 'vue'
import gql from 'graphql-tag'
export default Vue.extend({

  props: {
    label: {
      type: String,
      required: false,
      default: 'Search a user to assign:'
    },
    companyId: {
      type: String,
      required: false,
    },
    userId: {
      type: String,
      default: '',
      required: false
    },
    inputName: {
      type: String,
      default: 'userId',
      required: false
    }
  },
    
  data() {
    return{
      searchString: '',
    }
  },
  

  apollo: {
    userMany: {
      query: gql`
        query UsersMany($companyId: ID) {
          userMany(
            limit: 100000,
            filter: {
              isEnabled: true,
              companyId: { equals: $companyId }
            }
          ) {
            id
            company {
              name
            }
            name
            title
            email
            isEnabled
            isCompanyOwner
            createdAt
            updatedAt
          }
        }
      `,
      variables() {
        return {
          companyId: this.companyId || undefined
        }
      },
      fetchPolicy: 'no-cache',
      update: data => data.userMany.sort((a, b) => {
        if (a.company.name === b.company.name) {
          return a.name.localeCompare(b.name)
        }
        return a.company.name.localeCompare(b.company.name)
      })
    }
  },

  computed: {
    filteredUsers() {
      if (this.searchString) {
        return this.userMany.filter(u => (
          u.name.toLowerCase().includes(this.searchString.toLowerCase()) ||
          u.company.name.toLowerCase().includes(this.searchString.toLowerCase()
        )))
      } else {
        return []
      }
    }
  },

  methods: {

    getUserOptions() {
      return this.userMany.map(u => ({
        value: u.id,
        label: `[${u.company.name}] ${u.name}`
      }))
    },

    onUserChange(e) {
      this.$emit('input', e.target.value)
      this.$emit('input-full-object', this.userMany.find(u => u.id === e.target.value))
    },

  },
    
})
</script>